module.exports = __webpack_public_path__ + "static/add-task-43837883039ed5d32f1faaa02ef137ae.webp";